import React from 'react';
import request from 'arcdynamic-request';
import {AGENTS} from '../../consts/tables';
import AgentForm from "../AgentForm/AgentForm";
import Alert from "../Alert";
import FirmDrawer from "../FirmDrawer/FirmDrawer";
import { CREATE_UPDATE_AGENT } from '../Graphql/mutations';
import { ApolloConsumer } from '@apollo/client';
import { CREATE_OR_UPDATE_CONTACTS_AGENTS } from '../Graphql/ContactsMutations/allContactsMutation';
import { mutateData} from '../Service/graphQlService'
export default class AgentDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            paneIndex: 0,
            isBusy: null,
            error: null,
            shouldOpenDrawer: false,
            newFirm: false,
        };
        this.client = null;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
        this.addNewItem = this.addNewItem.bind(this);
        this.savedNewFirm = this.savedNewFirm.bind(this);
    }
    
    componentDidUpdate(prevProps){
        if(prevProps.resetDrawer !== this.props.resetDrawer && this.props.resetDrawer === true)
            this.setState({data:{},error:null});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.openDrawerCallback) {
            this.setState({shouldOpenDrawer: true});
        }
    }

    savedNewFirm(newData) {
        // select the new item id & close drawer
        const key = this.state.addNewItemType;
        const state = {
            data: {...this.state.data, [key]: newData.ARCIMEDES_ROW_ID},
            newFirm: newData
        };
        this.setState(state);
    }

    addNewItem() {
        this.setState({addNewItemType: 'FIRM'});
        const renderedComponent = () =>
            <FirmDrawer savedNewItem={this.savedNewFirm}
                        closeDrawer={this.state.shouldOpenDrawer ? this.props.closeChildDrawer : null}
                        resetDrawer={this.props.resetChildDrawer}/>;

        if (this.state.shouldOpenDrawer)
            this.props.openDrawerCallback(renderedComponent);
    }

    handleSubmit(e) {
        e.preventDefault();
        //Added if consition newly earlier it was not there
        if (this.client) {
        this.saveData(this.client);
        }
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(data) {
        this.setState({data});
    }

    async saveData(client) {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        // return request(arc.path.api, {
        //     service: 'arcimedes',
        //     action: 'open.datasource.table.Data.updateByTableCode',
        //     params: [AGENTS, {
        //         value: [
        //             this.state.data,
        //         ],
        //     }],
        const token = localStorage.getItem('authToken');
        try {
            const input = {};

            // List of fields to include in the input
            const fields = [
                "first_name",
                "last_name",
                "email",
                "phone",
                "cell_phone",
                "firm"
            ];

            // Dynamically add fields to the input if they exist in `this.state.data`
            fields.forEach(field => {
                if (this.state.data[field]) {
                input[field] = this.state.data[field] ;
                }
            });
            input.contact_type = "Agent";
            input.firm = input.firm && input.firm.toString();
        // const res = await client.mutate({
        //     //mutation: CREATE_UPDATE_AGENT,
        //   mutation: CREATE_OR_UPDATE_CONTACTS_AGENTS,
        //   variables: {
        //     input: input
        //   },
        //   context: {
        //     headers: {
        //       authorization: `Bearer ${token}`,  // Bearer token added here
        //     },
        //   },
        // }) 

        const res = await mutateData(CREATE_OR_UPDATE_CONTACTS_AGENTS,  {input})
        //if (res && res.success) {
            //if (res && res.data.createOrUpdateAgent.success) {
            if (res && res.data.createOrUpdateContact.success) {
                this.setState({isBusy: false});
                //this.props.savedNewItem(res.data[0], this.state.newFirm);
                //this.props.savedNewItem(res.data.createOrUpdateAgent.agent, this.state.newFirm);
                this.props.savedNewItem(res.data.createOrUpdateContact.contact, this.state.newFirm);

                if (this.props.closeDrawer) {
                    this.props.closeDrawer();
                    setTimeout(() => this.setState({data: {}, newFirm: false}), 1000);
                }
            }else {
                this.setState({
                  isBusy: null,
                  //error: res && res.message ? res.message : 'Unspecified error',
                  //error: res && res.data.createOrUpdateAgentmessage ? res.data.createOrUpdateAgentmessage : 'Unspecified error',
                  error:  res && res.data && res.data.createOrUpdateContact  ? res.data.createOrUpdateContact.error ? res.data.createOrUpdateContact.error : res.data.createOrUpdateContact.message  ? res.data.createOrUpdateContact.message : "Unspecified error" : "Unspecified error",
                });
            }
        } catch (error) {
            console.error("Error in handleSubmit:", error);
          }
        
    }

    render() {
        const data = this.state.data;
        return (
            <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client;
                }
                return (
            <React.Fragment>
                <AgentForm data={data}
                           paneIndex={this.state.paneIndex}
                           handleSubmit={this.handleSubmit}
                           handleCancel={this.props.closeDrawer}
                           handleParentChange={this.handleChange}
                           handleParentDropdownChange={this.handleDropdownChange}
                           handlePaneChange={(key) => this.setState({paneIndex: key})}
                           addNewItem={this.addNewItem}
                           newFirm={this.state.newFirm}
                />
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
            </React.Fragment>
            )
        }}

    </ApolloConsumer>
        );
    }
}

